import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledList = styled.div`
  margin-top: 2rem;
  width: 100%;

  & header {
    font-weight: 400;
    margin-bottom: 1rem;
  }
  & main {
    overflow-y: scroll;
    height: 100%;
    border: 1px solid ${getColor('catskillWhite')};
    & .row {
      display: flex;
      padding: 1rem 2rem;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
      &.isSelected {
        background-color: ${getColor('titanWhite')};
      }
    }
  }
`;

export const StyledGitOrganizationForm = styled.div`
  height: 100%;
  & ${StyledList} {
    &.git-integration-list {
      height: 35%;
      padding-bottom: 3%;
    }
    &.git-organization-list {
      height: 30%;
      & > main {
        &.fullscale {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
`;
